import React from 'react'

const Loading = (props) => (
    <div
        className={
            'w-100 text-center' +
            ((!props.no_space &&
                ' my-' + ((typeof props.size !== 'undefined' && props.size) || '5') + ' py-' + ((typeof props.size !== 'undefined' && props.size) || '5')) ||
                '')
        }
    >
        <div className="spinner-border loading-icon" role="status">
            <span className="sr-only">Loading...</span>
        </div>
        {(props.text && <small className="d-block text-muted mt-1">{props.text}</small>) || null}
    </div>
)

export const InlineLoading = (props) => (
    <>
        <i className={'spinner-border loading-icon ' + props.className || ''}></i>
    </>
)

export default Loading
